<script>
import { Row, Col } from 'vant'
import Game from '@/tbs/model/to/Game'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'game-stats-mode',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-row': Row,
        'van-col': Col,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        homePlayerList: Array,
        awayPlayerList: Array,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
    emits: ['edit-player'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            locale: new Game
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onEditBtnClick(player) {
            console.log('onEditBtnClick', player)
            this.$emit('edit-player', player)
        },
        playerField(player) {
            return this.locale.localeProp('event-player-label', {
                num: player.num ? player.num : '', 
                name: player.name
            })
        },
    },
}
</script>

<template>
    <!-- component -->
    <div class="game-stats-mode bg-white">
        <div class="graphic-section u-outer-padding flex">
            <div class="home-section inline-block">
                <div class="card-width"/>
                <div 
                    v-for="player in homePlayerList" 
                    :key="player.id" 
                    class="player-card main-secondary-color"
                >
                    <div class="title">
                        <span class="minor-text">{{ playerField(player) }}</span>
                        <span class="iconfont iconfont-edit pull-right" @click="onEditBtnClick(player)"></span>
                    </div>
                    <div class="stats t-outer-margin">
                        <van-row>
                            <van-col v-if="player.goalCount>0" class="vertical-center b-inner-margin" span="8">
                                <img src="@/assets/match-team-game/goal-symbol.svg"/>
                                <span class="l-inner-margin minor-text">x{{ player.goalCount }}</span>
                            </van-col>
                            <van-col v-if="player.penaltyGoalCount>0" class="vertical-center b-inner-margin" span="8">
                                <img src="@/assets/match-team-game/penalty-goal-symbol.svg"/>
                                <span class="l-inner-margin minor-text">x{{ player.penaltyGoalCount }}</span>
                            </van-col>
                            <van-col v-if="player.ownGoalCount>0" class="vertical-center b-inner-margin" span="8">
                                <img src="@/assets/match-team-game/own-goal-symbol.svg"/>
                                <span class="l-inner-margin minor-text">x{{ player.ownGoalCount }}</span>
                            </van-col>
                            <van-col v-if="player.assistCount>0" class="vertical-center b-inner-margin" span="8">
                                <img src="@/assets/match-team-game/assist-symbol.svg"/>
                                <span class="l-inner-margin minor-text">x{{ player.assistCount }}</span>
                            </van-col>
                            <van-col v-if="player.yellowCardCount>0" class="vertical-center b-inner-margin" span="8">
                                <img src="@/assets/match-team-game/yellow-card-symbol.svg"/>
                                <span class="l-inner-margin minor-text">x{{ player.yellowCardCount }}</span>
                            </van-col>
                            <van-col v-if="player.redCardCount>0" class="vertical-center b-inner-margin" span="8">
                                <img src="@/assets/match-team-game/red-card-symbol.svg"/>
                                <span class="l-inner-margin minor-text">x{{ player.redCardCount }}</span>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </div>
            <div class="away-section inline-block">
                <div class="card-width"/>
                <div 
                    v-for="player in awayPlayerList" 
                    :key="player.id" 
                    class="player-card main-secondary-color"
                >
                    <div class="title">
                        <span class="minor-text">{{ playerField(player) }}</span>
                        <span class="iconfont iconfont-edit pull-right" @click="onEditBtnClick(player)"></span>
                    </div>
                    <div class="stats t-outer-margin">
                        <van-row>
                            <van-col v-if="player.goalCount>0" class="vertical-center b-inner-margin" span="8">
                                <img src="@/assets/match-team-game/goal-symbol.svg"/>
                                <span class="l-inner-margin minor-text">x{{ player.goalCount }}</span>
                            </van-col>
                            <van-col v-if="player.penaltyGoalCount>0" class="vertical-center b-inner-margin" span="8">
                                <img src="@/assets/match-team-game/penalty-goal-symbol.svg"/>
                                <span class="l-inner-margin minor-text">x{{ player.penaltyGoalCount }}</span>
                            </van-col>
                            <van-col v-if="player.ownGoalCount>0" class="vertical-center b-inner-margin" span="8">
                                <img src="@/assets/match-team-game/own-goal-symbol.svg"/>
                                <span class="l-inner-margin minor-text">x{{ player.ownGoalCount }}</span>
                            </van-col>
                            <van-col v-if="player.assistCount>0" class="vertical-center b-inner-margin" span="8">
                                <img src="@/assets/match-team-game/assist-symbol.svg"/>
                                <span class="l-inner-margin minor-text">x{{ player.assistCount }}</span>
                            </van-col>
                            <van-col v-if="player.yellowCardCount>0" class="vertical-center b-inner-margin" span="8">
                                <img src="@/assets/match-team-game/yellow-card-symbol.svg"/>
                                <span class="l-inner-margin minor-text">x{{ player.yellowCardCount }}</span>
                            </van-col>
                            <van-col v-if="player.redCardCount>0" class="vertical-center b-inner-margin" span="8">
                                <img src="@/assets/match-team-game/red-card-symbol.svg"/>
                                <span class="l-inner-margin minor-text">x{{ player.redCardCount }}</span>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </div>
        </div>
        <div class="indicator-section">
            <div class="fixed-upon-bottom wp100 bg-white">
                <van-row type="flex" justify="center" class="u-outer-padding">
                    <van-col span="4" class="vertical-center justify-center">
                        <img src="@/assets/match-team-game/goal-symbol.svg"/>
                        <span class="l-inner-margin minor-text">{{ locale['goal'] }}</span>
                    </van-col>
                    <van-col span="4" class="vertical-center justify-center">
                        <img src="@/assets/match-team-game/penalty-goal-symbol.svg"/>
                        <span class="l-inner-margin minor-text">{{ locale['penalty-goal'] }}</span>
                    </van-col>
                    <van-col span="4" class="vertical-center justify-center">
                        <img src="@/assets/match-team-game/own-goal-symbol.svg"/>
                        <span class="l-inner-margin minor-text">{{ locale['own-goal'] }}</span>
                    </van-col>
                    <van-col span="4" class="vertical-center justify-center">
                        <img src="@/assets/match-team-game/assist-symbol.svg"/>
                        <span class="l-inner-margin minor-text">{{ locale['assist'] }}</span>
                    </van-col>
                    <van-col span="4" class="vertical-center justify-center">
                        <img src="@/assets/match-team-game/yellow-card-symbol.svg"/>
                        <span class="l-inner-margin minor-text">{{ locale['yellow-card'] }}</span>
                    </van-col>
                    <van-col span="4" class="vertical-center justify-center">
                        <img src="@/assets/match-team-game/red-card-symbol.svg"/>
                        <span class="l-inner-margin minor-text">{{ locale['red-card'] }}</span>
                    </van-col>
                </van-row>
            </div>
        </div>
    </div>
</template>

<style scoped>
.home-section {
    padding-right: 15px;
    border-right: 1px solid #D8D8D8;
}
.away-section {
    padding-left: 16px;
    /*border-left: 1px solid #D8D8D8;*/
}
.card-width {
    width: 139px;
    height: 1px;
    padding: 8px 8px 2px 8px;
}
.player-card {
    width: 139px;
    border-radius: 4px;
    background: #F7F8FA;
    margin-bottom: 16px;
    padding: 8px 8px 2px 8px;
}
.indicator-section {
    height: 36px;
}
</style>